// src/components/cierreGeneral/DateRangeBar.jsx
import React, { useMemo } from 'react';

// helper: YYYY-MM-DD hoy (CR) usando el navegador (suficiente para UI)
function todayISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export default function DateRangeBar({
  start,
  end,
  onChangeStart,
  onChangeEnd,
  onSubmit,
  loading,
  error,
}) {
  const defaults = useMemo(() => {
    const t = todayISO();
    return { start: start || t, end: end || t };
  }, [start, end]);

  return (
    <div className="cg-rangebar">
      <div className="cg-rangebar-left">
        <div className="cg-field">
          <label className="cg-label">Desde</label>
          <input
            className="cg-input"
            type="date"
            value={start || defaults.start}
            onChange={(e) => onChangeStart?.(e.target.value)}
          />
        </div>

        <div className="cg-field">
          <label className="cg-label">Hasta</label>
          <input
            className="cg-input"
            type="date"
            value={end || defaults.end}
            onChange={(e) => onChangeEnd?.(e.target.value)}
          />
        </div>

        <button
          className="cg-btn cg-btn-primary"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? 'Consultando...' : 'Consultar'}
        </button>
      </div>

      <div className="cg-rangebar-right">
        {error ? <div className="cg-inline-error">{error}</div> : null}
      </div>
    </div>
  );
}
